import axios from 'axios';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import { morphism, StrictSchema } from 'morphism';
import Format from 'app/src/data/Format';

export interface IEmployee {
  firstName: string;
  lastName: string;
  employeeID: number;
}

const employeeSchema: StrictSchema<IEmployee> = {
  employeeID: {
    path: 'employeeID',
    fn: propertyValue => {
      return Format.parseInt(propertyValue, 0);
    },
  },
  firstName: 'firstName',
  lastName: 'lastName',
};

export const transformEmployeeList = (data = { Employee: [] }): Array<IEmployee> => {
  let employees: Array<any> = data.Employee || [];
  if (!Array.isArray(employees)) {
    employees = [employees];
  }
  return employees.map((employee: any) => morphism(employeeSchema, employee));
};

export const endpoints = {
  getAllEmployees: () => URLHelper.getAccountURL('/Employee.json'),
};

export const getAllEmployees = async (): Promise<Array<IEmployee>> => {
  const response = await axios.get(endpoints.getAllEmployees());
  const { data } = response || {};
  return transformEmployeeList(data);
};
